import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function OnlineCourses() {
  const [t, i18n] = useTranslation("global");
  const [courses, setCourses] = useState([]);
  const [joinedCourses, setJoinedCourses] = useState([]);
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userDataLogin"));
  const token = userData?.token;
  const lang = localStorage.getItem("lang")?.replace(/"/g, "") || "en";

  useEffect(() => {
    fetchCourses();
    if (token && userData?.user?.type !== "student") {
      fetchJoinedCourses();
    }
  }, [i18n.language]);

  const fetchCourses = async () => {
    const endpoint = token
      ? `${process.env.REACT_APP_API_URL}/courses`
      : `${process.env.REACT_APP_API_URL}/random_course`;

    try {
      const response = await fetch(endpoint, {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
          "Accept-Language": i18n.language,
        },
      });

      const result = await response.json();
      setCourses(result?.data || []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      toast.error(t("messages.fetchCoursesError"));
    }
  };

  const fetchJoinedCourses = async () => {
    if (userData?.user?.type === "student") return;

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/joint_course`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": lang,
        },
      });

      const result = await response.json();
      setJoinedCourses(result?.data || []);
    } catch (error) {
      console.error("Error fetching joined courses:", error);
      toast.error(t("messages.fetchJoinedError"));
    }
  };

  const handleCardClick = async (course) => {
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/payment_course/${course.id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();

      if (course.type === "free") {
        if (result?.code === 200 || result?.status === 200) {
          navigate(`/CourseDetails/${course.id}`);
          toast.success(result.message || "تم عرض الكورس المجاني بنجاح");
        } else {
          toast.error(result.message || "فشل عرض الكورس المجاني");
        }
      } else if (course.type === "paid") {
        if (course.purshed === 1) {
          navigate(`/CourseDetails/${course.id}`);
          toast.success("تم عرض الكورس المدفوع بنجاح");
        } else {
          if (result?.redirect_url) {
            window.location.href = result.redirect_url;
          } else {
            console.error("Redirect URL Missing:", result);
            toast.error(result.message || "فشل بدء الدفع للكورس المدفوع");
          }
        }
      }
    } catch (error) {
      toast.error("حدث خطأ أثناء محاولة الاشتراك في الكورس");
      console.error("Error:", error);
    }
  };

  const renderCourseCard = (course, index) => {
    let courseImage = "";
    try {
      const images = JSON.parse(course.image);
      courseImage = images[0];
    } catch {
      courseImage = course.image;
    }

    const instructor = course.instructors?.[0];

    return (
      <div
        key={course.id || index}
        className="col-xl-4 col-lg-6 col-12 mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => handleCardClick(course)}
      >
        <div className="card p-4 h-100">
          <img src={courseImage} className="card-img-top img-instructor" alt={course.name} />
          <div className="card-body p-0">
            <h5 className="card-title fw-bold main-color">{course.name}</h5>
            <p className="card-text paragraph-color">
              {course.stage} - {course.grade}
            </p>
          </div>
          <div className="d-flex my-3 justify-content-between flex-wrap">
            <div className="d-flex align-items-center gap-1 mb-2">
              {instructor && (
                <>
                  <img
                    src={instructor.image}
                    alt={instructor.name}
                    className="rounded-circle"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                  <div className="ms-2">
                    <h6 className="main-color m-0">{instructor.name}</h6>
                    <p className="paragraph-color instructor-position m-0">{instructor.position}</p>
                  </div>
                </>
              )}
            </div>
            <div className="d-flex align-items-center lesson-file gap-1">
              <i className="bi bi-journal-text paragraph-color me-2"></i>
              <p className="paragraph-color m-0">
                {course.lessons} {t("onlineCourses2.lessons")}
              </p>
            </div>
          </div>
          <div>
            <p
              className="paragraph-color mb-2 text-center"
              style={{ fontSize: "20px", color: "#ff7f3e" }}
            >
              {course.type === "free" ? t("onlineCourses2.free") : course.price}
            </p>
            <p
              className="paragraph-color m-0 text-center"
              style={{ fontSize: "16px", marginTop: "70px" }}
            >
              {course.purshed === "1" || course.type === "free" ? t("join") : t("subscribe")}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="container py-5 online-courses">
      <div>
        <h1 className="main-color-2 m-0">{t("onlineCourses.titleOne")}</h1>
        <h1 className="main-color-2 m-0">{t("onlineCourses.titleTwo")}</h1>
        <div className="d-flex justify-content-between flex-wrap my-3 gap-2">
          <p className="paragraph-color">{t("onlineCourses.description")}</p>
          <Link to="/courses">
            <span className="second-color">
              {t("onlineCourses.view")}{" "}
              {lang === "ar" ? <i className="bi bi-arrow-left"></i> : <i className="bi bi-arrow-right"></i>}
            </span>
          </Link>
        </div>
      </div>

      <div className="row justify-content-center">
        {(joinedCourses.length > 0 ? joinedCourses.slice(0, 3) : courses.slice(0, 3)).map(
          (course, index) => renderCourseCard(course, index)
        )}
      </div>
    </section>
  );
}
